  import * as turf from "@turf/turf";

/**
 * Build 4 corner coordinates for a Mapbox "image" source from:
 * center + width/height (meters) + rotation (degrees clockwise from north).
 *
 * Returns corners in Mapbox-required order:
 * [top-left, top-right, bottom-right, bottom-left]
 */
export function getImageOverlayCorners(centerLngLat, widthM, heightM, rotationDeg = 0) {
  const [lng, lat] = centerLngLat;
  const center = turf.point([lng, lat]);

  const halfW = widthM / 2;
  const halfH = heightM / 2;

  // angle from north to the corner vector when unrotated
  const alphaRad = Math.atan2(halfW, halfH);
  const alphaDeg = (alphaRad * 180) / Math.PI;

  // distance from center to any corner
  const dist = Math.sqrt(halfW * halfW + halfH * halfH);

  // Bearings for each corner vector (in local space), then rotated
  const tlBearing = rotationDeg - alphaDeg;           // (-w, +h)
  const trBearing = rotationDeg + alphaDeg;           // (+w, +h)
  const brBearing = rotationDeg + (180 - alphaDeg);   // (+w, -h)
  const blBearing = rotationDeg + (180 + alphaDeg);   // (-w, -h)

  const tl = turf.destination(center, dist, tlBearing, { units: "meters" }).geometry.coordinates;
  const tr = turf.destination(center, dist, trBearing, { units: "meters" }).geometry.coordinates;
  const br = turf.destination(center, dist, brBearing, { units: "meters" }).geometry.coordinates;
  const bl = turf.destination(center, dist, blBearing, { units: "meters" }).geometry.coordinates;

  return [tl, tr, br, bl];
}
